import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  constructor(private oidcSecurityService: OidcSecurityService) {}
  userName: string;
  ngOnInit() {
    this.oidcSecurityService.getUserData().subscribe((userData) => {
      this.userName = userData?.given_name;
    });
  }
}
